import type { FC } from "react";
import React from "react";

import { PageContainer } from "@react/web/app";

import { PlaygroundView } from "../features/playground/index.ts";

export const Playground: FC = () => (
  <PageContainer>
    <PlaygroundView />
  </PageContainer>
);
